import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { CloudDownloadIcon } from "@fluentui/react-icons-mdl2-branded";
import { Link } from "@fluentui/react/lib/Link";
import { Text } from "@fluentui/react/lib/Text";
import { TooltipHost } from "@fluentui/react/lib/Tooltip";

import { WithTranslator } from "Components/Generic/Translator";
import { useStaging } from "Components/Toolbar/Hooks/UseStaging";
import { uiSetActiveProjectId, uiSetDetailsOpen } from "Store/Actions";
import { FilterToolTipContent } from "Components/Generic/FilterToolTipContent";
import { Stack } from "@fluentui/react";
import { INameRendererProps } from "./INameRendererProps";
import { useNameRendererStyles } from "./UseNameRendererStyles";
import { TooltipDirection, TooltipCloseDelay, TooltipOpenDelay } from "../TooltipSettings";

export const NameRenderer = WithTranslator((props: INameRendererProps): JSX.Element => {
  const {
    fieldName, item, translator, styles
  } = props;
  const styleSet = useNameRendererStyles(styles);
  const id = item?.[`@id`];
  const hasUpdate = item?.[`@hasUpdate`] ?? false;
  const content = item?.[fieldName]?.toString();

  const dispatch = useDispatch();

  const [, onStaging] = useStaging();

  const openDetails = useCallback(() => {
    dispatch(uiSetActiveProjectId(id));
    dispatch(uiSetDetailsOpen(true));
  }, [dispatch, id]);

  return (
    <Stack horizontal className={styleSet.root}>
      {hasUpdate && (
        <Stack.Item>
          <TooltipHost delay={TooltipOpenDelay} content={translator.get(`toolbar.staging`, `Source data update`)}>
            <Link onClick={onStaging}>
              <CloudDownloadIcon className={styleSet.icon} />
            </Link>
          </TooltipHost>
        </Stack.Item>
      )}

      <Stack.Item className={styleSet.name}>
        <TooltipHost
          closeDelay={TooltipCloseDelay}
          content={<FilterToolTipContent fieldName={fieldName} value={content} />}
          delay={TooltipOpenDelay}
          directionalHint={TooltipDirection}
          hostClassName={styleSet.host}
        >
          <Text>
            <Link as="a" onClick={openDetails} className={styleSet.link}>
              {content}
            </Link>
          </Text>
        </TooltipHost>
      </Stack.Item>
    </Stack>
  );
});
